(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ProcoreIframeHelpers", [], factory);
	else if(typeof exports === 'object')
		exports["ProcoreIframeHelpers"] = factory();
	else
		root["ProcoreIframeHelpers"] = factory();
})(window, function() {
return 